import type { ListFetcherCustomProps } from "./list-fetcher-custom.type";

import { useListFetcherCustomHandler } from "./list-fetcher-custom.hook";

const ListFetcherCustom = (props: ListFetcherCustomProps) => {
  useListFetcherCustomHandler(props);

  return null;
};

export default ListFetcherCustom;
